module.exports = __webpack_public_path__ + "img/avatar.b12c0d8e.svg";